import { render } from "./EditAlaUne.vue?vue&type=template&id=dabceb70&ts=true"
import script from "./EditAlaUne.vue?vue&type=script&lang=ts"
export * from "./EditAlaUne.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__